import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=02d4cf25"
import script from "./credits.vue?vue&type=script&lang=ts"
export * from "./credits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports